<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
  <div
    class="flex sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 sm:pt-12 sm:pb-28 sm:px-10 bg-default dark:bg-transparent"
  >
    <div class="flex-1 min-w-0 flex items-center justify-between">
      <div class="mt-2">
        <h2
          class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate"
        >
          Welcome {{ currentAdminName }}
        </h2>
      </div>
      <!-- <div class="flex shrink-0 items-center sm:ml-4">
                <button class="ml-3" mat-flat-button [routerLink]="'/contact-us'" [color]="'primary'">Contact
                    Us</button>
            </div> -->
    </div>
  </div>

  <ng-container *ngIf="canViewDashboard(); else noAccess">
    <div
      class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card"
      cdkScrollable
    >
      <div *ngIf="pageLoader" class="loaderMain">
        <div>
          <img
            src="assets/TrailFusion/Trail-Fusion-logo.jpg"
            class="LoaderImage"
          />
          <p class="loaderText">{{ pageLoaderText }}</p>
        </div>
      </div>

      <div *ngIf="!pageLoader">
        <button mat-flat-button color="accent" [routerLink]="'/profile-detail'">
          <mat-icon>how_to_reg</mat-icon>
          My Info
        </button>
      </div>
      <br /><br />

      <!-- Statistics Cards -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-10">
        <!-- Total Programs Card -->
        <div
          class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg shadow p-6 flex flex-col border border-blue-200 hover:shadow-md transition-shadow duration-300"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-medium text-blue-800">Total Programs</h3>
            <mat-icon class="text-blue-600">school</mat-icon>
          </div>
          <div class="mt-4">
            <p class="text-3xl font-bold text-blue-900">
              {{ stats.totalPrograms }}
            </p>
          </div>
        </div>

        <!-- Total Students Card -->
        <div
          class="bg-gradient-to-br from-green-50 to-green-100 rounded-lg shadow p-6 flex flex-col border border-green-200 hover:shadow-md transition-shadow duration-300"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-medium text-green-800">
              Total Registrations
            </h3>
            <mat-icon class="text-green-600">people</mat-icon>
          </div>
          <div class="mt-4">
            <p class="text-3xl font-bold text-green-900">
              {{ stats.totalStudents }}
            </p>
          </div>
        </div>

        <!-- Active Sessions Card -->
        <div
          class="bg-gradient-to-br from-amber-50 to-amber-100 rounded-lg shadow p-6 flex flex-col border border-amber-200 hover:shadow-md transition-shadow duration-300"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-medium text-amber-800">Active Sessions</h3>
            <mat-icon class="text-amber-600">event_available</mat-icon>
          </div>
          <div class="mt-4">
            <p class="text-3xl font-bold text-amber-900">
              {{ stats.activeSessions }}
            </p>
            <p class="text-sm text-amber-800 mt-2">
              {{ stats.sessionsToday }} happening today
            </p>
          </div>
        </div>

        <!-- Total Communities Card -->
        <div
          class="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg shadow p-6 flex flex-col border border-purple-200 hover:shadow-md transition-shadow duration-300"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-medium text-purple-800">
              Total Communities
            </h3>
            <mat-icon class="text-purple-600">location_city</mat-icon>
          </div>
          <div class="mt-4">
            <p class="text-3xl font-bold text-purple-900">
              {{ stats.totalCommunities }}
            </p>
          </div>
        </div>
      </div>

      <!-- Calendar Container -->
      <div
        class="calendar-container p-4 bg-white rounded-xl shadow-md space-y-4 mat-elevation-z4"
      >
        <!-- Header -->
        <div class="flex items-center justify-between flex-wrap gap-2">
          <div class="flex items-center gap-2">
            <button
              mat-icon-button
              (click)="prevMonth()"
              aria-label="Previous Month"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>
            <h2 class="text-lg font-semibold text-gray-800">
              {{ monthNames[currentMonth] }} {{ currentYear }}
            </h2>
            <button
              mat-icon-button
              (click)="nextMonth()"
              aria-label="Next Month"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
          <button mat-stroked-button color="primary" (click)="goToToday()">
            Today
          </button>
        </div>

        <!-- Weekday Header -->
        <div
          class="grid grid-cols-7 gap-1 text-center font-semibold text-gray-600 border-b pb-2"
        >
          <div *ngFor="let day of dayNames" class="uppercase text-xs">
            {{ day }}
          </div>
        </div>

        <!-- Calendar Grid -->
        <div class="grid grid-rows-6 gap-1">
          <div *ngFor="let week of weeks" class="grid grid-cols-7 gap-1">
            <div
              *ngFor="let day of week"
              class="relative rounded-lg p-2 min-h-[70px] cursor-pointer transition hover:ring-2 hover:ring-blue-400"
              [class.bg-gray-100]="!day.isCurrentMonth"
              [class.bg-blue-50]="day.isToday"
              [style.backgroundColor]="day.color"
              (click)="openDayRemark(day.date)"
            >
              <div class="text-sm font-medium text-gray-800">{{ day.day }}</div>

              <!-- Sessions -->
              <div
                *ngIf="day.hasSessions"
                class="absolute bottom-2 left-2 flex items-center gap-1 text-blue-600 text-xs"
              >
                <mat-icon class="!text-base">event</mat-icon>
                <span>{{ day.sessionCount }}</span>
              </div>

              <!-- Remarks -->
              <div
                class="text-[10px] truncate mt-1 text-white"
                *ngIf="day.remark"
              >
                {{ day.remark }}
                <mat-icon class="!text-base">note</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Remark Dialog -->
      <ng-container *ngIf="selectedDay">
        <!-- Backdrop -->
        <div
          class="fixed inset-0 bg-black bg-opacity-50 z-40"
          (click)="cancelRemark()"
        ></div>

        <!-- Dialog Box -->
        <div
          class="fixed top-1/2 left-1/2 z-50 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-md p-6 bg-white rounded-2xl shadow-lg space-y-4"
        >
          <h3 class="text-xl font-semibold text-gray-800 text-center">
            Add Remark for {{ selectedDay | date : "mediumDate" }}
          </h3>

          <!-- Textarea Input -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Remark</mat-label>
            <textarea matInput [(ngModel)]="remarkText" rows="3"></textarea>
          </mat-form-field>

          <!-- Color Picker -->
          <div class="flex items-center gap-3 justify-center flex-wrap">
            <div
              *ngFor="let color of colorOptions"
              class="w-8 h-8 rounded-full border-2 cursor-pointer transition-all duration-200"
              [ngClass]="{
                'ring-2 ring-offset-2 ring-blue-500 border-white':
                  color === remarkColor
              }"
              [style.backgroundColor]="color"
              (click)="remarkColor = color"
            ></div>
          </div>

          <!-- Action Buttons -->
          <div class="flex justify-end gap-3 pt-4">
            <button mat-stroked-button color="warn" (click)="cancelRemark()">
              Cancel
            </button>
            <button mat-raised-button color="primary" (click)="saveRemark()">
              Save
            </button>
          </div>
        </div>
      </ng-container>

      <br />

      <!-- Program Distribution Card -->
      <div
        *ngIf="canViewPrograms() && stats.programDistribution.length > 0"
        class="bg-white rounded-lg shadow p-6 mb-10"
      >
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-medium">Program Distribution by Category</h3>
        </div>
        <div class="h-60 flex items-center justify-center">
          <canvas #programChart></canvas>
        </div>
      </div>

      <!-- Management Sections -->
      <div class="space-y-10">
        <!-- Class Schedules Section -->
        <div>
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-2xl font-bold">Upcoming Classes</h3>
            <!-- <button mat-stroked-button [routerLink]="'/class-schedules'">
              <mat-icon>schedule</mat-icon>
              View All Classes
            </button> -->
          </div>
          <div class="bg-white rounded-lg shadow overflow-hidden">
            <table mat-table [dataSource]="upcomingClasses" class="w-full">
              <!-- Program Column -->
              <ng-container matColumnDef="program">
                <th mat-header-cell *matHeaderCellDef>Program</th>
                <td mat-cell *matCellDef="let class">{{ class.program }}</td>
              </ng-container>

              <!-- Instructor Column -->
              <ng-container matColumnDef="instructor">
                <th mat-header-cell *matHeaderCellDef>Instructor</th>
                <td mat-cell *matCellDef="let class">{{ class.instructor }}</td>
              </ng-container>

              <!-- Students Column -->
              <ng-container matColumnDef="students">
                <th mat-header-cell *matHeaderCellDef>Registered Students</th>
                <td mat-cell *matCellDef="let class">
                  {{ class.students }}/{{ class.capacity }}
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let class">
                  <span
                    class="px-2 py-1 rounded-full text-xs 
                                        {{
                      class.status === 'Ended'
                        ? 'bg-green-100 text-green-800'
                        : class.status === 'In Progress'
                        ? 'bg-blue-100 text-blue-800'
                        : 'bg-gray-100 text-gray-800'
                    }}"
                  >
                    {{ class.status }}
                  </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="scheduleColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: scheduleColumns"></tr>
            </table>
            <div class="p-4 text-center" *ngIf="upcomingClasses.length === 0">
              No upcoming classes scheduled
            </div>
          </div>
        </div>

        <!-- Recent Programs Section -->
        <div>
          <div
            *ngIf="canViewPrograms()"
            class="flex items-center justify-between mb-4"
          >
            <h3 class="text-2xl font-bold">Recent Programs</h3>
            <button mat-stroked-button [routerLink]="'/program-list'">
              <mat-icon>list_alt</mat-icon>
              View All Programs
            </button>
          </div>
          <div class="bg-white rounded-lg shadow overflow-hidden">
            <table mat-table [dataSource]="recentPrograms" class="w-full">
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let program">{{ program.name }}</td>
              </ng-container>

              <!-- Type Column -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Category</th>
                <td mat-cell *matCellDef="let program">{{ program.type }}</td>
              </ng-container>

              <!-- Location Column -->
              <ng-container matColumnDef="location">
                <th mat-header-cell *matHeaderCellDef>Community</th>
                <td mat-cell *matCellDef="let program">
                  {{ program.location }}
                </td>
              </ng-container>

              <!-- Participants Column -->
              <ng-container matColumnDef="participants">
                <th mat-header-cell *matHeaderCellDef>Total Registered</th>
                <td mat-cell *matCellDef="let program">
                  {{ program.participants }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="programColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: programColumns"></tr>
            </table>
            <div class="p-4 text-center" *ngIf="recentPrograms.length === 0">
              No programs created yet
            </div>
          </div>
        </div>

        <!-- Attendance & Payments Section -->
        <div
          *ngIf="canViewAttendance() || canViewReports()"
          class="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          <!-- Attendance Summary -->
          <div *ngIf="canViewAttendance()">
            <h3 class="text-2xl font-bold mb-4">Attendance Summary</h3>
            <div class="bg-white rounded-lg shadow p-6">
              <div
                class="h-64"
                *ngIf="
                  attendanceStats.weeklyTrend.length > 0;
                  else noAttendanceData
                "
              >
                <canvas #attendanceChart></canvas>
              </div>
              <ng-template #noAttendanceData>
                <div
                  class="h-64 flex items-center justify-center text-gray-500"
                >
                  <div class="text-center">
                    <mat-icon class="text-gray-400 mb-2">bar_chart</mat-icon>
                    <p>No attendance data available</p>
                  </div>
                </div>
              </ng-template>
              <div class="mt-4 flex justify-between">
                <div>
                  <p class="text-sm text-gray-500">Today's Attendance</p>
                  <p class="text-xl font-bold">
                    {{ attendanceStats.todayPresent }} present /
                    {{ attendanceStats.todayTotal }} registered
                    <span class="block text-sm mt-1"
                      >({{ attendanceStats.todayPercentage }}%)</span
                    >
                  </p>
                </div>
                <div>
                  <p class="text-sm text-gray-500">Monthly Average</p>
                  <p class="text-xl font-bold">
                    {{ attendanceStats.monthlyAverage }}%
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Payments Summary -->
          <div *ngIf="canViewReports()">
            <h3 class="text-2xl font-bold mb-4">Payments Summary</h3>
            <div class="bg-white rounded-lg shadow p-6">
              <div
                class="h-64"
                *ngIf="
                  paymentStats.monthlyTrend &&
                    paymentStats.monthlyTrend.length > 0;
                  else noPaymentData
                "
              >
                <canvas #paymentsChart></canvas>
              </div>
              <ng-template #noPaymentData>
                <div
                  class="h-64 flex items-center justify-center text-gray-500"
                >
                  <div class="text-center">
                    <mat-icon class="text-gray-400 mb-2">payments</mat-icon>
                    <p>No payment data available</p>
                  </div>
                </div>
              </ng-template>
              <div class="mt-4 flex justify-between">
                <div>
                  <p class="text-sm text-gray-500">This Month</p>
                  <p class="text-xl font-bold">
                    {{ paymentStats.monthlyTotal | currency }}
                  </p>
                </div>
                <div>
                  <p class="text-sm text-gray-500">Outstanding</p>
                  <p class="text-xl font-bold">
                    {{ paymentStats.outstanding | currency }}
                  </p>
                </div>
              </div>
              <div>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #noAccess>
    <div class="no-access-message text-center p-8">
      <mat-icon class="icon text-6xl text-amber-500 mb-4">warning</mat-icon>
      <h2 class="text-2xl font-bold text-gray-800 mb-2">Access Restricted</h2>
      <p class="text-gray-600 mb-1">
        You don't have permission to view the dashboard content.
      </p>
      <p class="text-gray-600">
        Please contact your administrator if you need access.
      </p>
    </div>
  </ng-template>
</div>
